import { ContentSearchResultEntry } from '../services';
import { SearchViewTransformerProps } from '../types/searchTypes';

export const transformContentSearchResults = (data: ContentSearchResultEntry[]) =>
  data.map(({ title, snippets, display_link }) => ({
    title,
    description: snippets?.[0] ?? '',
    link: display_link,
  }));

export const transformContentCardSearchResults = (data: ContentSearchResultEntry[]) =>
  data.map(({ title, snippets, display_link, content_card, promotion_date, sub_category }) => ({
    title,
    description: snippets?.[0] ?? '',
    link: display_link,
    imageUrl: content_card?.thumbnail_image,
    promotionDate: promotion_date,
    tag: sub_category,
    readMinutes: content_card?.read_time,
    backgroundColor: content_card?.color?.background_color,
    textColor: content_card?.color?.text_color,
  }));

export const searchViewTransformer = <T>(data: T) => {
  const { searchResults, text, search_type, offersSearchResults, articlesSearchResults } =
    data as SearchViewTransformerProps;
  const searchCategorySet = ['products'];
  const searchResultsSet = [searchResults?.total?.toString()];
  if (offersSearchResults && offersSearchResults?.search_results) {
    searchCategorySet.push('offers');
    searchResultsSet.push(offersSearchResults?.total_size?.toString());
  }
  if (articlesSearchResults && articlesSearchResults?.search_results) {
    searchCategorySet.push('articles');
    searchResultsSet.push(articlesSearchResults?.total_size?.toString());
  }
  const transformedData = {
    search_category: searchCategorySet,
    search_keyword: text,
    search_type,
    search_results: searchResultsSet,
  };
  return transformedData;
};
